import { render } from "./OrderContact.vue?vue&type=template&id=4edbe102"
import script from "./OrderContact.vue?vue&type=script&lang=js"
export * from "./OrderContact.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/orders.cash-mere.ch/releases/80909800/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__